export default {
  slots: {
    identity: {
      label: 'Henkilöllisyystodistus',
      hint: 'Henkilökortti, passi tai oleskelulupa, etu- ja takapuoli. Myös kumppaneidesi henkilöllisyystodistukset lisätään tähän.',
    },
    trade_registration: {
      label: 'Elinkeinoilmoitus (Gewerbeanmeldung)',
      hint: 'Elinkeinoilmoitus, jonka sait elinkeinovirastolta.',
    },
    commercial_register_extract: {
      label: 'Kaupparekisteriote (Handelsregisterauszug)',
      hint: 'Ajantasainen kaupparekisteriote, jos yrityksesi on rekisteröity sinne.',
    },
    bank_statement: {
      label: 'Tiliote (Kontoauszug)',
      hint: 'Yritystilisi tuore tiliote, josta näkyvät tilinhaltija ja IBAN.',
    },
    shareholder_list: {
      label: 'Osakasluettelo (Gesellschafterliste)',
      hint: 'Ajantasainen osakasluettelo.',
      hint_gbr: 'Yhtiösopimuksesi (Gesellschaftsvertrag) tai luettelo kaikista yhtiömiehistä.',
    },
    tax_number: {
      label: 'Verotunnus tai ALV-tunnus (Steuernummer oder USt-IdNr.)',
      hint: 'Verotoimistolta saamasi kirje, josta näkyy verotunnuksesi, tai ALV-tunnuksen vahvistus.',
    },
  },
  tags: {
    required: 'Pakollinen',
    optional: 'Valinnainen',
    missing: 'Puuttuu',
  },
  kinds: {
    passport: 'Passi',
    driver_license: 'Ajokortti',
    id_card: 'Henkilökortti',
    residence_permit: 'Oleskelulupa',
  },
  holders: {
    owner: 'Omistaja',
    partner: 'Kumppani: {{name}}',
  },
  file: {
    with_back: 'Etu- ja takapuoli',
    uploaded_at: 'Ladattu {{date}}',
    expires_at: 'Voimassa {{date}} asti',
  },
  errors: {
    load: 'Tiedostoja ei voitu ladata.',
  },
  empty: 'Ei vielä tiedostoa',
  buttons: {
    add: 'Lisää tiedosto',
    replace: 'Korvaa',
    remove: 'Poista',
    retry: 'Yritä uudelleen',
  },
  remove_confirm: {
    title: 'Poistetaanko tämä tiedosto?',
    description: 'Käytä tätä, jos lisäsit tiedoston vahingossa.',
    ok: 'Poista',
    cancel: 'Peruuta',
  },
  toasts: {
    remove_success: 'Tiedosto poistettu',
    remove_error: 'Tiedostoa ei voitu poistaa. Yritä uudelleen.',
  },
};
